import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Providers } from '@/components/layout/Providers';
import { Loader } from '@/components/ui/Loader';
import { AppRoutes } from '@/routes';
import { useDocumentTitle } from '@/lib/useDocumentTitle';

function AppContent() {
  useDocumentTitle();
  return (
    <Suspense fallback={<Loader text="INITIALIZING SYSTEM…" />}>
      <AppRoutes />
    </Suspense>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Providers>
        <AppContent />
      </Providers>
    </BrowserRouter>
  );
}
